module.exports = __webpack_public_path__ + "img/blacksmith.ba1a909c.png";